var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.661 10.8294C18.3364 10.3835 17.8384 10.1271 17.2945 10.1271H16.9991V8.77226C16.9991 6.8924 15.5039 5.36302 13.666 5.36302H10.2956C10.1929 5.36302 10.0889 5.33779 9.99757 5.29142L7.89437 4.21546C7.61838 4.07432 7.30907 4 6.99975 4H5.6665C4.19593 3.99932 3 5.22256 3 6.72672V15.5908C3 17.4706 4.49524 19 6.33313 19H14.7046C16.1885 19 17.4711 18.0236 17.9058 16.5406L18.927 12.3704C19.083 11.8372 18.9857 11.276 18.661 10.8294ZM4.33325 15.5908V6.72672C4.33325 5.97464 4.93121 5.36302 5.6665 5.36302H6.99975C7.10242 5.36302 7.20641 5.38825 7.29774 5.43461L9.40094 6.51057C9.67692 6.65171 9.98624 6.72603 10.2956 6.72603H13.666C14.7686 6.72603 15.6659 7.6438 15.6659 8.77158V10.1264H8.74298C7.60972 10.1264 6.59778 10.8621 6.21714 11.981L4.75723 16.8481C4.49191 16.501 4.33325 16.0646 4.33325 15.5908ZM17.6418 12.009L16.6205 16.1785C16.3645 17.0506 15.5946 17.6363 14.7046 17.6363H6.33313C6.19447 17.6363 6.05915 17.622 5.92849 17.594L7.48439 12.4058C7.67038 11.8583 8.17702 11.4908 8.74365 11.4908H17.2951C17.4564 11.4908 17.5504 11.5863 17.5918 11.6435C17.6331 11.7008 17.6958 11.8201 17.6418 12.009Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchives);
export default __webpack_public_path__ + "static/media/Archives.619e0a0e3a8b4915af2385209d0e59c0.svg";
export { ForwardRef as ReactComponent };